import Vuex from 'vuex'
import Vue from 'vue'
import area from './module/area'
import waybill from './module/waybill'
import finance from './module/finance'
import admin from './module/admin'
import app from './module/app'
import tagsView from './module/tagsView'
import theme from './module/theme'
import site from './module/site'
import home from './module/home'
Vue.use(Vuex)
const getters = {
    device: (state) => state.app.device,
    token: state => state.token,
    menuList: state => state.menuList,
    mobileMenuList: state => state.mobileMenuList,
    userInfo:(state)=>state.userInfo?state.userInfo:state.admin.userInfo,
    scopeId: (state) => state.admin.scopeId,
    userEnt: (state) => state.admin.userEnt,
    agentInfo: (state) => state.admin.agentInfo,
    sidebar: (state) => state.app.sidebar,
    sysDwidth: (state) => state.app.sysDwidth,
    allMenu: (state) => state.admin.allMenu,
    breadcrumb: (state) => state.admin.breadcrumb,
    sidebarMenu: (state) => state.admin.sidebarMenu,
    sysDwidth: (state) => state.app.sysDwidth,
    isAgent: (state) => state.admin.isAgent,
    judgeRouteShowObj:(state) => state.admin.judgeRouteShowObj,
    userEntList: state => state.admin.userEntList,
}
const state = {
    token: '',
    menuList:[
        {name:"网络货运",link:"/"},
        {name:"云仓平台",link:""},
        {name:"运输管理",link:""},
        {name:"招标平台",link:""},
        {name:"交易平台",link:""},
        {name:"大宗贸易",link:""},
        {name:"登录",link:"/account/login"},
        {name:"注册",link:"/account/register"},

    ],
    mobileMenuList:[
        {name:"网络货运",link:"/"},
        {name:"云仓平台",link:""},
        {name:"运输管理",link:""},
        {name:"招标平台",link:""},
        {name:"交易平台",link:""},
        {name:"大宗贸易",link:""},
        {name:"控制中心",link:"/admin/dashboard/home"}

    ],
    userInfo:null,

    pageType:0,
}
const mutations = {
    SET_TOKEN: (state, val) => {
        
        state.token = val
    },
    SET_USERINFO: (state, val) => {
        state.userInfo = val
    },
    SET_SCOPEID: (state, val) => {
        state.scopeId = val
    },
}
const actions = {
    setToken: ({ commit }, val) => {
        commit('SET_TOKEN',val)
    },
    setUserInfo:({ commit }, val) => {
        commit('SET_USERINFO',val)
    },
      setIsAgent({commit,state},val){
        commit('admin/SET_ISAGENT', val)
      }
      
      
}
const store = new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules:{
        area,
        waybill,
        finance,
        admin,
        app,
        tagsView,
        theme,
        site,
        home
    }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js